// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3c9pm","header":"Settings_header__2jeYz","title":"Settings_title__3y04s","tabs":"Settings_tabs__2_K8O","active":"Settings_active__2fFeC"};